import { configureStore } from '@reduxjs/toolkit'
import authSlice from '../features/auth/authSlice'
import clientsSlice from '../features/clients/clientsSlice'
import projectsSlice from '../features/projects/projectsSlice'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    projects: projectsSlice,
    clients: clientsSlice
  }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
